import { Link } from "react-router-dom";
import { MapPin, MessageCircle, Mail, BookOpen } from "lucide-react";
import { waLink } from "@/lib/api";

export const Footer = ({ property }) => (
  <footer data-testid="main-footer" className="border-t border-line bg-cream">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <p className="font-display text-4xl leading-tight text-ink sm:text-5xl">
        Queluz <span className="text-clay">Cardoso</span>
      </p>
      <div className="mt-8 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-fog">
        <span className="flex items-center gap-2" data-testid="footer-address">
          <MapPin size={14} className="text-clay" /> {property?.address || property?.location || "Queluz, Lisboa"}
        </span>
        <a
          data-testid="footer-whatsapp-link"
          href={waLink(property?.whatsapp, "Olá! Gostaria de saber mais sobre o apartamento.")}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 transition-colors duration-300 hover:text-clay"
        >
          <MessageCircle size={14} className="text-clay" /> {property?.whatsapp}
        </a>
        {property?.email && (
          <a data-testid="footer-email-link" href={`mailto:${property.email}`} className="flex items-center gap-2 transition-colors duration-300 hover:text-clay">
            <Mail size={14} className="text-clay" /> {property.email}
          </a>
        )}
        <Link data-testid="footer-admin-link" to="/admin" className="transition-colors duration-300 hover:text-clay">
          Gestão
        </Link>
      </div>
      <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-fog" data-testid="footer-legal-links">
        <Link data-testid="footer-privacy-link" to="/privacidade" className="transition-colors duration-300 hover:text-clay">Política de Privacidade</Link>
        <Link data-testid="footer-terms-link" to="/termos" className="transition-colors duration-300 hover:text-clay">Termos e Condições</Link>
        <a
          data-testid="footer-complaints-link"
          href="https://www.livroreclamacoes.pt/Inicio/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 transition-colors duration-300 hover:text-clay"
        >
          <BookOpen size={14} className="text-clay" /> Livro de Reclamações
        </a>
      </div>
      <p className="mt-10 text-xs text-fog/70">
        © {new Date().getFullYear()} {property?.name}. Todos os direitos reservados.
      </p>
      <p className="mt-2 text-xs text-fog/70" data-testid="footer-credits">
        Desenvolvido por <span className="text-clay">grupo-dipanda</span>
      </p>
    </div>
  </footer>
);
